module.exports = __webpack_public_path__ + "img/Arrak_Landscape_Color.8f8c82db.jpg";